import { formatTime12h } from '../constants/hrmsAttendanceDetails.constants'
import type { StaffAttendanceRecord } from '../types/hrmsAttendanceRecords.types'

interface AttendanceTimelineProps {
  record: StaffAttendanceRecord
}

export function AttendanceTimeline({ record }: AttendanceTimelineProps) {
  const events: { time: string; label: string }[] = []

  if (record.checkIn && record.checkIn !== 'none') {
    const sourceSuffix = record.source ? ` (${record.source})` : ''
    events.push({
      time: formatTime12h(record.checkIn),
      label: `Check In${sourceSuffix}`,
    })
  }

  if (record.checkOut && record.checkOut !== 'none') {
    const sourceSuffix = record.source ? ` (${record.source})` : ''
    events.push({
      time: formatTime12h(record.checkOut),
      label: `Check Out${sourceSuffix}`,
    })
  }

  return (
    <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-xs min-w-0">
      <h3 className="text-sm font-semibold text-slate-800 mb-3">Attendance Timeline</h3>

      {events.length === 0 ? (
        <p className="text-xs text-slate-500 italic">No punches recorded for this date.</p>
      ) : (
        <div className="relative pl-5 border-l-2 border-slate-200 space-y-4 my-2 ml-2">
          {events.map((evt, idx) => (
            <div key={idx} className="relative flex items-center min-w-0">
              <div className="absolute -left-[27px] top-1/2 -translate-y-1/2 h-4 w-4 rounded-full bg-white border-2 border-[#146971] flex items-center justify-center shrink-0">
                <span className="h-1.5 w-1.5 rounded-full bg-[#146971]" />
              </div>
              <div className="text-xs text-slate-700 min-w-0 truncate">
                <span className="font-bold text-slate-900 mr-2">{evt.time}</span>
                <span>{evt.label}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
